// extracted by mini-css-extract-plugin
export default {"checkbox":"CustomCheckboxV2_checkbox__9loU2"};